module.exports = ".button-center {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-item-align: center;\r\n      align-self: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  width: 100%;\r\n  margin-top: 40px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/edit-quiz/edit-quiz.component.css
// module id = ./src/app/edit-quiz/edit-quiz.component.css
// module chunks = main